export default "__VITE_PUBLIC_ASSET__a188dfb4__"